import { LandingScope } from 'mormaii-web-presentation/landing'
import type { ViewFactory } from 'wdc-cube-solid'

import { LandingView } from './v-landing'

export function registerViews(rv: typeof ViewFactory.register) {
    rv(LandingScope, LandingView)
}

export { LandingView }
